import axios from "axios";

export const fetchMenus = async () => {
  try {
    const response = await axios.get("http://localhost:8080/webnet-hms/api/menus/all");
    const rawData = response.data.data;
    const flatData = rawData.flat();
    return flatData;
  } catch (error) {
    console.error("Error fetching menus:", error);
    return [];
  }
};
export const fetchMenusMain = async () => {
  try {
    const response = await axios.get("http://localhost:8080/webnet-hms/api/menus/all/main-menu");
    const rawData = response.data.data;
    const flatData = rawData.flat();
    return flatData;
  } catch (error) {
    console.error("Error fetching menus:", error);
    return [];
  }
};
export const fetchMenuspl = async () => {
  try {
    const response = await axios.get("http://localhost:8080/webnet-hms/api/menus/parent-zero/");
    return response.data;
  } catch (error) {
    console.error("Error fetching menus:", error);
    return [];
  }
};
export const fetchMenu1 = async (id) => {
  try {
    const response = await axios.get(`http://localhost:8080/webnet-hms/api/menus/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching menus:", error);
    return [];
  }
};
